import { useContext, useEffect, useMemo } from 'react';

import { useEventTracking } from '@/utilities/hooks/useEventTracking';

import { eventsTracked } from './actions/EventsTracked';
import { dataManagerContext } from './dataManagerContext';
import { logError } from './logError';
import { crumble } from './TrackingEvent';

export function useTrackEvents() {
  const { state, dispatch } = useContext(dataManagerContext);
  const { trackEvent } = useEventTracking();

  const trackingEvents = useMemo(() => state.trackingEvents, [state]);

  useEffect(() => {
    if (trackingEvents.length > 0) {
      trackingEvents.forEach(e => {
        trackEvent(e.type, e.blob)?.catch(reason => {
          logError('Error tracking event', reason, crumble(e));
        });
      });
      dispatch(eventsTracked);
    }
  }, [trackingEvents, trackEvent, dispatch]);
}
